import { useQuery } from 'urql';
import { suburbPageQuery } from './suburbPageQuery';
import { getSlugFromPathname } from '../../helpers/getSlugFromPathname';
import { useUrlContext } from '../../contexts/UrlContext/UrlContext';

export const useSuburbPageQuery = () => {
  const url = useUrlContext();

  const [result] = useQuery({
    query: suburbPageQuery,
    variables: {
      slug: getSlugFromPathname(url.pathname),
    },
  });

  return result;
};
